import axios from "axios";
import { Axios } from "index";

export const addExpenseType = async (details) => {
  try {
    const config = {
      withCredentials: true,
      headers: {
        withCredentials: true,
      },
    };
    const data = await axios.post(
      `${process.env.REACT_APP_URL}/expenseType-master/add-expenseType-master`,
      details,
      config
    );
    // console.log(data);
    return data;
  } catch (error) {
    // console.log(error);
    return error.response;
  }
};

export const updateExpenseType = async (details, id) => {
  try {
    const config = {
      withCredentials: true,
      headers: {
        withCredentials: true,
      },
    };
    const data = await axios.post(
      `${process.env.REACT_APP_URL}/expenseType-master/update-expenseType-master?id=${id}`,
      details,
      config
    );
    return data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const expenseTypeDropDownList = async () => {
  try {
    const data = await Axios.get(`/expenseType-master/dropdown-expenseType-master`);
    return data;
  } catch (error) {
    return error?.response?.data;
  }
};

